import { render } from "./index.vue?vue&type=template&id=06562bf5"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/campaigns-detail/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06562bf5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06562bf5', __exports__)) {
    api.reload('06562bf5', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=06562bf5", () => {
    api.rerender('06562bf5', render)
  })

}


export default __exports__